import * as errors from "../errors.js";
import { state } from "../state.js";

/*
    The numeric function COS is a mathematical function which evaluates to the cosine for a given angle, a number considered to be in radians.
    If the term given in the parentheses is non-numerical, the BASIC error ?TYPE MISMATCH ERROR occurs. If the argument expression is not in 
    the range of a floating point value the execution yields the BASIC error ?OVERFLOW ERROR. Omitting the numeric argument or providing to 
    many arguments results in a ?SYNTAX ERROR. 
*/
export const cos = async (args) => {
    // If no args are given, throw a syntax error.
    if (args.length === 0) {
        throw new errors.SyntaxError();
    }

    // Check if the args is a number.
    if (isNaN(args)) {
        throw new errors.TypeMismatchError();
    }

    if (Math.abs(args) > state.maxValue) {
        throw new errors.OverflowError();
    }

    // Calculate the cosine.
    const result = Math.cos(args);

    // Check for overflow (if the result is not a finite number).
    if (Math.abs(result) > state.maxValue) {
        throw new errors.OverflowError();
    }

    // Return the result.
    return result;
};